import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface UserProfile {
  id: string;
  email?: string;
  phone_number?: string;
  kakao_id?: string;
  telegram_id?: string;
  is_admin: boolean;
  level: number;
  created_at: string;
  updated_at: string;
}

export interface Reservation {
  id: string;
  store_name: string;
  reservation_date: string;
  reservation_time: string;
  phone_number?: string;
  kakao_id?: string;
  telegram_id?: string;
  user_id?: string;
  created_at: string;
}
